module.exports = __webpack_public_path__ + "media/images/faq/6-100-9f7db7cc9b77b7398ba8c2931cbb50fd.jpg";